import {
  CreateAdminCMSRequestInterface,
  DeleteAdminCMSRequestInterface,
  UpdateAdminCMSInterface,
} from '../contracts/AdminRequest'

export class CreateAdminCMSRequest implements CreateAdminCMSRequestInterface {
  private name: string
  private email: string
  private password: string
  private sales_code: string
  private role_id: number

  constructor(
    name: string,
    email: string,
    password: string,
    sales_code: string,
    role_id: number
  ) {
    this.name = name
    this.email = email
    this.password = password
    this.sales_code = sales_code
    this.role_id = role_id
  }

  public toJSON() {
    const data = {
      name: this.name,
      email: this.email,
      password: this.password,
      sales_code: this.sales_code,
      role_id: this.role_id,
    }

    return JSON.stringify({
      data,
    })
  }
}

export class UpdateAdminCMSRequest implements UpdateAdminCMSInterface {
  private name: string
  private email: string
  private password: string
  private role_id: number

  constructor(name: string, email: string, password: string, role_id: number) {
    this.name = name
    this.email = email
    this.password = password
    this.role_id = role_id
  }

  public toJSON() {
    const data = {
      name: this.name,
      email: this.email,
      password: this.password,
      role_id: this.role_id,
    }

    return JSON.stringify({
      data,
    })
  }
}

export class DeleteAdminRequest implements DeleteAdminCMSRequestInterface {
  private ids: number

  constructor(ids: any) {
    this.ids = ids
  }
  public toJSON() {
    const Ids = this.ids
    return JSON.stringify({
      Ids,
    })
  }
}
